import Controller from "./stations.controller";
import template from "./stations.html";

const stations = {
  template,
  controller: Controller,
};

export default stations;



// WEBPACK FOOTER //
// ./src/pages/stations/stations.component.js